export const GET_LCR_COUNTS = 'GET_LCR_COUNTS'
export const GET_LCR_DATA = 'GET_LCR_DATA'
export const GET_LCR_SALESPERSONS = 'GET_LCR_SALESPERSONS'
